<template>
  <div style="height: 100vh; background: #f5f7fa; min-width: 1000px">
    <el-dialog
      :title="drawer ? '更改数据源' : '添加图表'"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="dialogBeforeClose"
    >
      <div style="max-height: 50vh; overflow: auto">
        <el-tree
          :data="moduleList"
          :props="{
            children: 'items',
            label: 'name',
          }"
          @node-click="handleRowClick"
        ></el-tree>
      </div>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="设置过滤条件"
      :visible.sync="filterVisible"
      width="350px"
      :before-close="filterVisibleClose"
    >
      <div style="max-height: 50vh; overflow: auto">
        <div class="center">
          <el-input
            v-model="activeFilter.name"
            disabled
            style="flex: 1; gap: 10px"
          ></el-input>
          <el-dropdown
            trigger="click"
            style="padding: 0 10px; cursor: pointer"
            @command="setFilterMethod"
          >
            <span class="el-dropdown-link">
              {{
                activeFilter.method
                  ? filterData[activeFilter?.type]?.options.find(
                      (item) => item.value === activeFilter.method
                    )?.label
                  : "请选择"
              }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(item, index) in filterData[activeFilter?.type]?.options"
                :key="index"
                :command="item.value"
                >{{ item.label }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div
          style="margin-top: 10px"
          v-if="
            activeFilter.method !== 'empty' &&
            activeFilter.method !== 'not_empty'
          "
        >
          <el-input
            v-model="activeFilterValue"
            style="flex: 1; gap: 10px"
          ></el-input>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="filterVisible = false">取 消</el-button>
        <el-button type="primary" @click="filterSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <el-container>
      <el-header style="height: 52px; position: relative">
        <el-image
          style="
            width: 100%;
            height: 52px;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
          "
          src="https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/11/顶部@2x-110454966.png"
        ></el-image>
        <div class="between header">
          <el-image
            style="width: 16px; height: 16px; cursor: pointer"
            src="https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/11/返回@2x-111941849.png"
            @click="goBack"
          ></el-image>

          <el-button type="primary" size="mini" @click="pageSubmit"
            >保存</el-button
          >
        </div>
      </el-header>
      <el-container>
        <el-aside width="200px" style="background: #fff; padding-top: 20px">
          <div class="flex" style="flex-direction: column">
            <div
              v-for="item in type"
              :key="item.value"
              class="type"
              @click="addType(item.value)"
            >
              {{ item.name }}
            </div>
          </div>
        </el-aside>
        <el-main style="height: calc(100vh - 52px); position: relative">
          <grid-layout
            :layout.sync="previewList"
            :col-num="60"
            :row-height="10"
            :is-draggable="true"
            :is-resizable="true"
            :vertical-compact="true"
            :margin="[10, 10]"
            :use-css-transforms="true"
            @layout-updated="layoutUpdatedEvent"
          >
            <grid-item
              v-for="(item, index) in previewList"
              :key="index"
              :x="item.x"
              :y="item.y"
              :w="item.w"
              :h="item.h"
              :i="item.i"
              style="touch-action: none"
            >
              <el-card style="width: 100%; height: 100%; user-select: none">
                <SummarySheet
                  :tableName="item.name"
                  :previewData="item.dataArr"
                  :previewVal="item"
                  v-if="item.type === 'pivot_table'"
                ></SummarySheet>
                <DataTable :previewData="item" v-else></DataTable>

                <div class="operate">
                  <div title="删除">
                    <el-popconfirm
                      title="确定删除该统计表？（删除后无法恢复）"
                      @confirm="deleteItem(item)"
                    >
                      <i class="el-icon-delete" slot="reference"></i>
                    </el-popconfirm>
                  </div>
                  <div title="编辑">
                    <i class="el-icon-edit" @click="editItem(item)"></i>
                  </div>
                </div>
              </el-card>
            </grid-item>
          </grid-layout>
        </el-main>
      </el-container>
    </el-container>

    <el-drawer
      :with-header="false"
      :visible.sync="drawer"
      direction="rtl"
      size="100%"
      :before-close="drawerClose"
    >
      <el-container>
        <el-header style="height: 52px; position: relative">
          <div class="center">
            <el-image
              style="
                width: 100%;
                height: 52px;
                position: absolute;
                top: 0;
                left: 0;
                z-index: 1;
              "
              src="https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/11/顶部@2x-110454966.png"
            ></el-image>
          </div>
          <div class="between header">
            <div class="center">
              <el-image
                style="width: 16px; height: 16px; cursor: pointer"
                src="https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/11/返回@2x-111941849.png"
                @click="drawerClose"
              ></el-image>
              <div style="margin-left: 10px">
                <el-input v-model="tableName" placeholder=""></el-input>
              </div>
            </div>

            <el-button type="primary" size="mini" @click="submit"
              >保存</el-button
            >
          </div>
        </el-header>
        <el-container>
          <el-aside
            width="200px"
            style="
              background: #fff;
              border-right: 1px solid #ebecee;
              display: flex;
              flex-direction: column;
              height: calc(100vh - 52px);
            "
          >
            <div style="padding: 10px 10px 10px 20px">
              <div class="between">
                <div>数据源</div>
                <el-button type="text" @click="dialogVisible = true"
                  >更改数据源</el-button
                >
              </div>
              <div style="font-size: 12px; overflow: auto; padding: 5px 0">
                {{ currentType.name || "请选择数据源" }}
              </div>
            </div>
            <div
              style="
                border-top: 1px solid #ebecee;
                padding: 10px 10px 10px 20px;
                flex: 1;
                height: 100%;
              "
            >
              <div>字段</div>

              <ul style="margin-top: 10px">
                <draggable
                  class="drag"
                  :list="groupComponents"
                  :options="{ sort: false }"
                  :group="{ name: 'form', pull: 'clone', put: false }"
                  @start="isStart = true"
                  @end="handleDragEnd"
                  :clone="clone"
                  filter=".undraggable"
                  :move="handleMove"
                >
                  <li
                    v-for="(cp, id) in groupComponents"
                    :key="id"
                    :class="{ undraggable: false }"
                    style="
                      font-size: 12px;
                      cursor: move;
                      height: 26px;
                      line-height: 26px;
                      overflow: hidden;
                    "
                  >
                    <span>{{ cp.name }}</span>
                  </li>
                </draggable>
              </ul>
            </div>
          </el-aside>
          <el-main style="height: calc(100vh - 52px); position: relative">
            <div style="padding: 16px" v-if="designType === 'pivot_table'">
              <div
                v-for="(item, index) in tableOption"
                :key="index"
                class="fx-dash-editor-main-axis-line"
              >
                <div class="line-label">
                  {{ item.label }}
                </div>
                <ul class="line-main">
                  <draggable
                    class="drag-from"
                    :class="[item.key]"
                    :list="item.groupComponents"
                    group="form"
                    :move="handleMove"
                    :options="{
                      animation: 300,
                      chosenClass: 'choose',
                      sort: true,
                    }"
                    @start="
                      drag = true;
                      selectFormItem = null;
                    "
                    @end="handleDragEnd"
                  >
                    <li
                      v-for="(cp, id) in item.groupComponents"
                      :key="id"
                      :class="{ undraggable: false }"
                      class="axis-field"
                    >
                      <el-tag
                        :type="item.type"
                        closable
                        @close="() => tagClose(cp.name, item.key)"
                        >{{ cp.name }}</el-tag
                      >
                    </li>
                  </draggable>
                </ul>
              </div>
              <SummarySheet
                :tableName="tableName"
                :previewData="previewData"
                :previewVal="previewVal"
              ></SummarySheet>
            </div>

            <div
              style="
                padding: 16px;
                height: 100%;
                display: flex;
                flex-direction: column;
              "
              v-if="designType === 'data_table'"
            >
              <div>
                <div
                  v-for="(item, index) in data_table"
                  :key="index"
                  class="fx-dash-editor-main-axis-line"
                >
                  <div class="line-label">
                    {{ item.label }}
                  </div>
                  <ul class="line-main">
                    <draggable
                      class="drag-from"
                      :class="[item.key]"
                      :list="item.groupComponents"
                      group="form"
                      :move="handleMove"
                      :options="{
                        animation: 300,
                        chosenClass: 'choose',
                        sort: true,
                      }"
                      @start="
                        drag = true;
                        selectFormItem = null;
                      "
                      @end="handleDragEnd"
                    >
                      <li
                        v-for="(cp, id) in item.groupComponents"
                        :key="id"
                        :class="{ undraggable: false }"
                        class="axis-field"
                      >
                        <el-tag
                          :type="item.type"
                          closable
                          @close="() => tagClose(cp.name, item.key)"
                          >{{ cp.name }}</el-tag
                        >
                      </li>
                    </draggable>
                  </ul>
                </div>
              </div>
              <div style="height: calc(100% - 120px)">
                <DataTable
                  :previewData="dataTableData"
                  v-if="dataTableData.data"
                ></DataTable>
              </div>
            </div>
          </el-main>
        </el-container>
      </el-container>
    </el-drawer>
  </div>
</template>
<script>
import {
  getFormGroups,
  getFormItemReport,
  getFormReportPreview,
  getFormListPreview,
  getReportPreview,
  getReportList,
  getReportData,
  getTableData,
  addDashboard,
  deleteReportList,
} from "@/api/design";
import draggable from "vuedraggable";
import { filterData } from "./filter";
import SummarySheet from "@/components/SummarySheet";
import DataTable from "@/components/DataTable";
import { GridLayout, GridItem } from "vue-grid-layout";

export default {
  name: "FormDesign",
  components: {
    draggable,
    SummarySheet,
    GridLayout,
    GridItem,
    DataTable,
  },
  data() {
    return {
      type: [
        {
          name: "统计表",
          value: "pivot_table",
        },
        {
          name: "明细表",
          value: "data_table",
        },
      ],
      dataTableData: {},
      dialogVisible: false,
      moduleList: [],
      currentType: "",
      drawer: false,
      data_table: [
        {
          label: "显示字段",
          key: "fields",
          groupComponents: [],
          type: "",
        },
        {
          label: "过滤条件",
          key: "filter",
          groupComponents: [],
          type: "info",
        },
      ],
      tableOption: [
        {
          label: "维度（行）",
          key: "xFields",
          groupComponents: [],
          type: "",
        },
        {
          label: "维度（列）",
          key: "yFields",
          groupComponents: [],
          type: "",
        },
        {
          label: "指标",
          key: "metrics",
          groupComponents: [],
          type: "success",
        },
        {
          label: "过滤条件",
          key: "filter",
          groupComponents: [],
          type: "info",
        },
      ],
      groupComponents: [],
      isStart: false,
      drag: false,
      tableData: [],
      data: {},
      filterVisible: false,
      activeFilter: {},
      filterData,
      activeFilterValue: "",
      previewData: {
        header: [],
        data: [],
      },
      previewVal: {},
      previewList: [],
      tableName: "未命名仪表盘",
      previewId: null,
      designType: null,
      designComponents: [],
      submitLoading: false,
    };
  },
  computed: {
    menuBar() {
      return JSON.parse(localStorage.getItem("menuBar"));
    },
  },
  created() {
    this.getModuleList();
    this.getList();
  },
  methods: {
    async editItem(item) {
      this.designType = item.type;
      console.log(item);
      this.currentType = {
        name: item.relationFormName,
        id: item.relationForm,
      };
      const res = await getFormItemReport({ formId: this.currentType.id });
      console.log(res);
      this.groupComponents = res.data;
      this.dialogBeforeClose();
      this.drawer = true;
    },
    async deleteItem(item) {
      this.previewList = this.previewList.filter((val) => val.i !== item.i);
      await deleteReportList(item.id);
      this.$message.success("删除成功");
    },
    layoutUpdatedEvent: function (newLayout) {
      this.designComponents = [...newLayout];
    },

    async getList() {
      this.previewList = [];
      const res = await getReportList(this.$route.query.code);
      res.data.forEach((item, index) => {
        if (item.type === "pivot_table") {
          getReportData({ id: item.id }).then(({ data: res }) => {
            const dataArr = {
              header: [],
              data: [],
            };
            res.yFields.forEach((item, index) => {
              const arr = [];
              arr.push(item.name);
              res.data.val.forEach((val) => {
                if (val.y) {
                  arr.push(val.y[index]);
                } else {
                  arr.push("汇总");
                }
              });
              dataArr.header.push(arr);
            });
            let xFields = [];
            if (res.xFields.length > 0) {
              xFields = res.xFields.map((item) => item.name);
            } else {
              xFields = [""];
            }
            res.data.val.forEach((val) => {
              xFields.push(val.name);
            });
            dataArr.header.push(xFields);
            let result = [];
            const sum = ["汇总"];
            if (res.data.x.length > 0) {
              const { x, val } = res.data;
              const dataLength = x[0].data.length;
              result = Array.from({ length: dataLength }, (_, i) => [
                ...x.map((item) => item.data[i]),
                ...val.map((item) => item.data[i]),
              ]);
              res.data.val.forEach((val) => {
                sum.push(val.sum);
              });
            } else {
              result = [];
              res.data.val.forEach((val) => {
                sum.push(val.sum);
              });
            }
            result.push(sum);
            dataArr.data = result;
            this.previewList.push({
              ...res,
              i: index,
              dataArr,
              type: "pivot_table",
            });
          });
        } else {
          getTableData({ id: item.id, pageNumber: 1, pageSize: 20 }).then(
            ({ data }) => {
              this.previewList.push({
                ...data,
                i: index,
                type: "data_table",
              });
            }
          );
        }
      });
    },

    async preview() {
      this.previewData.header = [];
      this.previewData.data = [];
      const obj = {
        relationForm: this.currentType.id,
        xFields: this.tableOption[0].groupComponents,
        yFields: this.tableOption[1].groupComponents,
        metrics: this.tableOption[2].groupComponents,
        filter: {
          cond: this.tableOption[3].groupComponents,
          rel: "and",
        },
        type: "pivot_table",
      };
      const { data: res } = await getFormReportPreview(obj);
      this.previewVal = res;
      res.yFields.forEach((item, index) => {
        const arr = [];
        arr.push(item.name);
        res.data.val.forEach((val) => {
          if (val.y) {
            arr.push(val.y[index]);
          } else {
            arr.push("汇总");
          }
        });
        this.previewData.header.push(arr);
      });
      let xFields = [];
      if (res.xFields.length > 0) {
        xFields = res.xFields.map((item) => item.name);
      } else {
        xFields = [""];
      }
      res.data.val.forEach((val) => {
        xFields.push(val.name);
      });
      this.previewData.header.push(xFields);
      let result = [];
      const sum = ["汇总"];
      if (res.data.x.length > 0) {
        const { x, val } = res.data;
        const dataLength = x[0].data.length;
        result = Array.from({ length: dataLength }, (_, i) => [
          ...x.map((item) => item.data[i]),
          ...val.map((item) => item.data[i]),
        ]);
        res.data.val.forEach((val) => {
          sum.push(val.sum);
        });
      } else {
        result = [];
        res.data.val.forEach((val) => {
          sum.push(val.sum);
        });
      }
      result.push(sum);
      this.previewData.data = result;
    },
    async submit() {
      if (this.submitLoading) return;
      if (this.designType === "pivot_table") {
        this.submitLoading = true;
        const obj = {
          relationForm: this.currentType.id,
          xFields: this.tableOption[0].groupComponents,
          yFields: this.tableOption[1].groupComponents,
          metrics: this.tableOption[2].groupComponents,
          filter: {
            cond: this.tableOption[3].groupComponents,
            rel: "and",
          },
          w: 30,
          h: 20,
          x: 0,
          y: 0,
          type: "pivot_table",
          name: this.tableName,
          id: this.previewId,
          formId: this.$route.query.code,
        };
        const res = await getReportPreview(obj);
        this.submitLoading = false;
        this.previewId = res.data.id;
        if (res.code === 200) {
          this.$message.success("保存成功");
        } else {
          this.$message.error(res.message);
        }
      } else {
        this.submitLoading = true;
        const obj = {
          relationForm: this.currentType.id,
          fields: this.data_table[0].groupComponents,
          filter: {
            cond: this.data_table[1].groupComponents,
            rel: "and",
          },
          type: "data_table",
          w: 30,
          h: 20,
          x: 0,
          y: 0,
          name: this.tableName,
          id: this.previewId,
          formId: this.$route.query.code,
        };
        const res = await getReportPreview(obj);
        this.submitLoading = false;
        this.previewId = res.data.id;
        if (res.code === 200) {
          this.$message.success("保存成功");
        } else {
          this.$message.error(res.message);
        }
      }
    },
    setFilterMethod(command) {
      this.$set(this.activeFilter, "method", command);
    },
    filterSubmit() {
      this.$set(this.activeFilter, "value", [this.activeFilterValue]);
      this.filterVisibleClose();
    },
    filterVisibleClose() {
      this.filterVisible = false;
    },
    handleDragEnd(e) {
      this.isStart = false;
      this.drag = false;

      if (this.designType === "pivot_table") {
        this.previewPivotTable(e);
      } else {
        this.previewTable(e);
      }
      // 遍历 tableOption 查找 xFields 和 yFields
    },
    async previewTable(e) {
      // 获取拖动的元素
      const draggedItem = e.item ? e.item._underlying_vm_ : null;
      if (!draggedItem) return;
      // 获取拖动的字段名称
      const fieldName = draggedItem.name;
      if (!fieldName) return;
      this.data_table.forEach((option) => {
        if (option.key === "fields") {
          // 统计该字段在当前选项中的出现次数
          const count = option.groupComponents.filter(
            (item) => item.name === fieldName
          ).length;
          // 如果该字段已存在且超过一个，则移除最后一个拖入的字段
          if (count > 1) {
            const lastFieldIndex = option.groupComponents
              .map((item) => item.name)
              .lastIndexOf(fieldName);

            if (lastFieldIndex !== -1) {
              option.groupComponents.splice(lastFieldIndex, 1);
            }
            // 提示用户
            this.$message.warning(`添加失败，同一字段不能重复添加`);
            return;
          }
        }
        if (option.key === "filter") {
          // 统计该字段在当前选项中的出现次数
          const count = option.groupComponents.filter(
            (item) => item.name === fieldName
          ).length;
          // 如果该字段已存在且超过一个，则移除最后一个拖入的字段
          if (count > 1) {
            const lastFieldIndex = option.groupComponents
              .map((item) => item.name)
              .lastIndexOf(fieldName);

            if (lastFieldIndex !== -1) {
              option.groupComponents.splice(lastFieldIndex, 1);
            }
            // 提示用户
            this.$message.warning(`添加失败，同一字段不能重复添加筛选条件`);
            return;
          }
        }
      });

      if (e.to._prevClass === "drag-from filter") {
        this.activeFilter = draggedItem;
        this.filterVisible = true;
      }

      if (this.data_table[0].groupComponents.length > 0) {
        const obj = {
          relationForm: this.currentType.id,
          fields: this.data_table[0].groupComponents,
          filter: {
            cond: this.data_table[1].groupComponents,
            rel: "and",
          },
          type: "data_table",
          pageNumber: 1,
          pageSize: 20,
        };
        const { data } = await getFormListPreview(obj);
        this.dataTableData = { ...data, type: "data_table" };
      }
    },
    previewPivotTable(e) {
      const draggedItem = e.item ? e.item._underlying_vm_ : null;
      if (!draggedItem) return;
      // 获取拖动的字段名称
      const fieldName = draggedItem.name;
      if (!fieldName) return;
      this.tableOption.forEach((option) => {
        if (option.key === "xFields" || option.key === "yFields") {
          // 统计该字段在当前选项中的出现次数
          const count = option.groupComponents.filter(
            (item) => item.name === fieldName
          ).length;
          // 如果该字段已存在且超过一个，则移除最后一个拖入的字段
          if (count > 1) {
            const lastFieldIndex = option.groupComponents
              .map((item) => item.name)
              .lastIndexOf(fieldName);

            if (lastFieldIndex !== -1) {
              option.groupComponents.splice(lastFieldIndex, 1);
            }
            // 提示用户
            this.$message.warning(`添加失败，同一字段不能重复添加维度`);
            return;
          }
        }

        if (option.key === "filter") {
          // 统计该字段在当前选项中的出现次数
          const count = option.groupComponents.filter(
            (item) => item.name === fieldName
          ).length;
          // 如果该字段已存在且超过一个，则移除最后一个拖入的字段
          if (count > 1) {
            const lastFieldIndex = option.groupComponents
              .map((item) => item.name)
              .lastIndexOf(fieldName);

            if (lastFieldIndex !== -1) {
              option.groupComponents.splice(lastFieldIndex, 1);
            }
            // 提示用户
            this.$message.warning(`添加失败，同一字段不能重复添加筛选条件`);
            return;
          }
        }

        if (option.key === "metrics") {
          if (draggedItem.type === "AmountInput") {
            draggedItem.op = "sum";
          } else {
            draggedItem.op = "count";
          }
        }
      });

      if (e.to._prevClass === "drag-from filter") {
        this.activeFilter = draggedItem;
        this.filterVisible = true;
      }

      if (
        (this.tableOption[0].groupComponents.length > 0 ||
          this.tableOption[1].groupComponents.length > 0) &&
        this.tableOption[2].groupComponents.length > 0
      ) {
        this.preview();
      }
    },
    handleMove(e) {
      // 检查拖拽到维度行或列时是否存在相同字段
      console.log(e);
    },
    clone(obj) {
      // obj.id = this.getId();
      return JSON.parse(JSON.stringify(obj));
    },
    async submitForm() {
      const res = await getFormItemReport({ formId: this.currentType.id });
      console.log(res);
      this.groupComponents = res.data;
      this.dialogBeforeClose();
      this.drawer = true;
    },
    drawerClose() {
      this.$confirm("图表设计有修改，是否保存？", "提示", {
        confirmButtonText: "保存",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.submit();
        })
        .catch(() => {
          this.drawer = false;
          this.getList();
        });
    },
    addType(type) {
      this.designType = type;
      this.dialogVisible = true;
    },
    async handleRowClick(row) {
      console.log(row);
      if (row.items) return;
      this.currentType = row;
    },
    async getModuleList() {
      const res = await getFormGroups(this.menuBar.id);
      const arr = [];
      res.data.forEach((item) => {
        if (item.items) {
          item.items.map((item) => (item.name = item.formName));
          arr.push(item);
        }
      });
      this.moduleList = arr;
    },
    dialogBeforeClose() {
      this.dialogVisible = false;
    },
    tagClose(fieldName, optionKey) {
      // 找到对应的选项（xFields或yFields）
      let targetOption = null;
      if (this.designType === "pivot_table") {
        targetOption = this.tableOption.find(
          (option) => option.key === optionKey
        );
      } else {
        targetOption = this.data_table.find(
          (option) => option.key === optionKey
        );
      }
      if (!targetOption) return;

      // 从groupComponents数组中移除该字段
      const index = targetOption.groupComponents.findIndex(
        (item) => item.name === fieldName
      );
      if (index !== -1) {
        targetOption.groupComponents.splice(index, 1);
        // this.$message.info(`字段 "${fieldName}" 已删除`);
      }
      if (this.designType === "pivot_table") {
        if (
          (this.tableOption[0].groupComponents.length > 0 ||
            this.tableOption[1].groupComponents.length > 0) &&
          this.tableOption[2].groupComponents.length > 0
        ) {
          this.preview();
        }
      }
    },

    goBack() {
      this.$confirm("仪表盘设计有修改，是否保存？", "提示", {
        confirmButtonText: "保存",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.pageSubmit();
        })
        .catch(() => {
          this.$router.go(-1);
        });
    },
    async pageSubmit() {
      if (this.submitLoading) return;
      this.submitLoading = true;
      await addDashboard({
        name: "测试",
        id: this.$route.query.code,
        components: this.designComponents,
      });
      this.submitLoading = false;
      this.$message.success("保存成功");
    },
  },
};
</script>
<style lang="less" scoped>
.header {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  height: 52px;
  padding: 0 16px;
  width: 100%;
  .el-input__inner {
    background-color: transparent;
    border: 1px solid transparent;
  }
}

.el-main {
  padding: 5px !important;
  display: flex;
  flex-direction: column;
}

.type {
  color: #1f1f1f;
  font-size: 14px;
  line-height: 20px;
  padding: 10px 42px;
  transition: all 0.3s;
  cursor: pointer;
  &.active {
    background: #f4f8fc;
    position: relative;
    &::before {
      content: " ";
      position: absolute;
      top: 0;
      left: 0;
      width: 4px;
      height: 100%;
      background: #107fff;
    }
  }
  &:hover {
    background: #f4f8fc;
  }
}
.fx-dash-editor-main-axis-line {
  border: 1px dashed #d7d9dc;
  border-radius: 3px;
  flex: 0 0 auto;
  line-height: 34px;
  margin-bottom: 10px;
  position: relative;
  .line-label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    left: 10px;
    position: absolute;
    top: 2px;
    width: 98px;
    z-index: 2;
  }
  .line-main {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    max-height: 90px;
    min-height: 34px;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 2.5px 10px 2.5px 108px;
    position: relative;
    .axis-field {
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-right: 10px;
    }
  }
}

.drag-from {
  width: 100%;
  height: 34px;
  display: flex;
  align-items: center;
}

.el-tag {
  display: flex;
  align-items: center;
  line-height: unset;
}

:deep(.el-tag .el-icon-close) {
  top: 1px;
}

:deep(.el-card__body) {
  padding: 10px;
  height: 100%;
  position: relative;
  .operate {
    position: absolute;
    top: 4px;
    right: 0;
    z-index: 2;
    padding-right: 10px;
    display: flex;
    cursor: pointer;
    align-items: center;
    padding-top: 5px;
    i {
      display: none;
      margin-left: 10px;
      font-size: 14px;
    }
  }
  &:hover {
    .operate {
      i {
        display: block;
      }
    }
  }
}

.vue-grid-item {
  &:hover {
    box-shadow: 0 0 0 3px #99e3d6;
  }
}
</style>
